import $ from "jquery";
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";

function openMenu() {
  disableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').addClass('active');
  $('.nav_mobile_e3f1').addClass('active');
}

function closeMenu() {
  enableBodyScroll(document.querySelector('.nav_mobile_e3f1__menu'));
  $('.nav_mobile_e3f1__trigger').removeClass('active');
  $('.nav_mobile_e3f1').removeClass('active');
}

$('.nav_mobile_e3f1__trigger').on('click', function(e){
  e.preventDefault();
  if($(this).hasClass('active')) {
    closeMenu();
  } else {
    openMenu();
  }
});

$('.nav_mobile_e3f1__menu i').on('click', function(){
  var $li = $(this).parent();
  if($li.hasClass('active')) {
    $li.removeClass('active');
  } else {
    $li.addClass('active');
  }
});

// var lastScrollPosition = 0;
// window.addEventListener("scroll", function(){
//   var currentScrollPosition = window.scrollY;
//   var myElement = $('.nav_mobile_e3f1');
//   var displayValue = myElement.css('display');
//   if (displayValue === 'none') {
//   } else {
//     if (window.scrollY < 3){
//       $('body').removeClass('mobile-scrolling');
//     } else{
//       if (currentScrollPosition < lastScrollPosition) {
//         $('body').addClass('mobile-scrolling');
//       } else {
//         $('body').removeClass('mobile-scrolling');
//       }

//     }
//   }
// });